module.exports = __webpack_public_path__ + "img/overiew-report-ill.92186afe.svg";